var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({staticClass:"fl-do-not-capture",attrs:{"state":_vm.localState,"maxlength":"20"},model:{value:(_vm.nationalID),callback:function ($$v) {_vm.nationalID=$$v},expression:"nationalID"}},'b-form-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }